import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseTextEntity from 'common/components/entities/BaseTextEntity'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryTitleInterface } from 'common/types/entities/BlogCategoryTitleInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import { generateBaseEntity } from 'client/utils/createStructureUtils'
import Badge from '../../../components/core/Badge'

function BlogCategoryTitle({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogCategoryTitleInterface>) {
  const { t } = useTranslation()

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <>
        <BaseTextEntity
          as="h1"
          id={entity.htmlAttrId}
          fontSize={entity.fontSize}
          fontFamily={entity.fontFamily}
          fontStyle={entity.fontStyle}
          fontWeight={entity.fontWeight}
          mobileFontSize={entity.mobileFontSize}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontStyle={entity.mobileFontStyle}
          mobileFontWeight={entity.mobileFontWeight}
          lineHeight={entity.lineHeight}
          mobileLineHeight={entity.mobileLineHeight}
          color={entity.color}
          mobileColor={entity.mobileColor}
          textAlign={entity.textAlign}
          mobileTextAlign={entity.mobileTextAlign}
        >
          {t('entities.blog_category_title.example')}
        </BaseTextEntity>
        <Badge wide>
          {t('entities.blog_category_title.warnings.do_not_remove')}
        </Badge>
      </>
    </BaseEntityNew>
  )
}

export function createBlogCategoryTitle(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogCategoryTitle,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.BlogCategoryTitle,
    parentId: parentId,
    fontSize: 42,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 12,
    textAlign: 'center',
  } as BlogCategoryTitleInterface
}

export default BlogCategoryTitle
